
import { isEmpty } from "../gui_components/Util.js";
import {ServiceExecutorProxy}from "./ServiceExecutorProxy.js";
export class PurchaseOrderReceiptService {
  constructor() {}
  static initService(appData) {
    this.sessionBean = JSON.parse(localStorage.getItem("session"));
    this.companyCode = appData.companyCode;
    this.po_data_url =
      appData.serviceURL + `/${process.env.REACT_APP_PR_SERVICE_PATH}`;
    localStorage.setItem("security_token", this.sessionBean.securityPass);
  }
  static getPurchaseOrderReceiptPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPurchaseOrderReceiptPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updatePurchaseOrderReceipt(input, responseCallBack, errorCallBack) {
    this.method(
      "updatePurchaseOrderReceipt",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createPurchaseOrderReceipt(input, responseCallBack, errorCallBack) {
    this.method(
      "createPurchaseOrderReceipt",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static initPurchaseOrderReceiptModule(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "initPurchaseOrderReceiptModule",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static approvePurchaseOrderReceipt(input, responseCallBack, errorCallBack) {
    this.method(
      "approvePurchaseOrderReceipt",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static cancelPurchaseOrderReceipt(input, responseCallBack, errorCallBack) {
    this.method(
      "cancelPurchaseOrderReceipt",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static cancelAndUnLockPurchaseOrderReceipt(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "cancelAndUnLockPurchaseOrderReceipt",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static unLockPurchaseOrderReceipt(input, responseCallBack, errorCallBack) {
    this.method(
      "unLockPurchaseOrderReceipt",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static unApprovePurchaseOrderReceipt(input, responseCallBack, errorCallBack) {
    this.method(
      "unApprovePurchaseOrderReceipt",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getPurchaseOrderReceiptListForLast3MonthsSalesInvoiceForFabricStyleStatistics(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPurchaseOrderReceiptListForLast3MonthsSalesInvoiceForFabricStyleStatistics",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getPurchaseOrderReceiptListForLast6MonthsSalesInvoiceForFabricStyleStatistics(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPurchaseOrderReceiptListForLast6MonthsSalesInvoiceForFabricStyleStatistics",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getPurchaseOrderReceiptListForLast12MonthsSalesInvoiceForFabricStyleStatistics(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPurchaseOrderReceiptListForLast12MonthsSalesInvoiceForFabricStyleStatistics",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getPurchaseOrderReceiptListForLast18MonthsSalesInvoiceForFabricStyleStatistics(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPurchaseOrderReceiptListForLast18MonthsSalesInvoiceForFabricStyleStatistics",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getPurchaseOrderReceiptListForLast24MonthsSalesInvoiceForFabricStyleStatistics(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPurchaseOrderReceiptListForLast24MonthsSalesInvoiceForFabricStyleStatistics",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static cancelPurchaseOrderReceiptLine(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "cancelPurchaseOrderReceiptLine",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static uploadExcelInput(input, responseCallBack, errorCallBack) {
    this.method("uploadExcelInput", input, responseCallBack, errorCallBack);
  }
  static getPurchaseOrderLinesDatasFromExcel(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPurchaseOrderLinesDatasFromExcel",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createAndApprovePurchaseOrderReceipt(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createAndApprovePurchaseOrderReceipt",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateAndApprovePurchaseOrderReceipt(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateAndApprovePurchaseOrderReceipt",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createInvoiceFromPurchaseOrderReceipt(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createInvoiceFromPurchaseOrderReceipt",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readPurchaseOrderReceipt(input, responseCallBack, errorCallBack) {
    this.method(
      "readPurchaseOrderReceipt",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static purchaseOrderRecieptImageUpload(input, responseCallBack, errorCallBack) {
    this.method("purchaseOrderRecieptImageUpload", input, responseCallBack, errorCallBack);
  }
  static purchaseReceiptDocumentUpload(input, responseCallBack, errorCallBack) {
    this.method("purchaseReceiptDocumentUpload", input, responseCallBack, errorCallBack);
  }

  static createPurchaseOrderReceiptApproval(input, responseCallBack, errorCallBack) {
    this.method("createPurchaseOrderReceiptApproval", input, responseCallBack, errorCallBack);
  }

  static readPurchaseOrderReceiptApproval(input, responseCallBack, errorCallBack) {
    this.method("readPurchaseOrderReceiptApproval", input, responseCallBack, errorCallBack);
  }

  static getPurchaseOrderReceiptApprovalLines(input, responseCallBack, errorCallBack) {
    this.method("getPurchaseOrderReceiptApprovalLines", input, responseCallBack, errorCallBack);
  }

  static getPurchaseOrderReceiptApprovalPageList(input, responseCallBack, errorCallBack) {
    this.method("getPurchaseOrderReceiptApprovalPageList", input, responseCallBack, errorCallBack);
  }

 static cancelAndUnLockPurchaseOrderReceiptAfterApproval(input, responseCallBack, errorCallBack) {
    this.method("cancelAndUnLockPurchaseOrderReceiptAfterApproval", input, responseCallBack, errorCallBack);
  }
  
static getPurchaseOrderReceiptLinesOverallInputFromExcel(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPurchaseOrderReceiptLinesOverallInputFromExcel",
      input,
      responseCallBack,
      errorCallBack
    );
  }  

  static method(methodName, input, responseCallBack, errorCallBack) {
    if (isEmpty(this.sessionBean)) {
    } else if (isEmpty(this.sessionBean.securityPass)) {
    } else {
      // const isFormData = input instanceof FormData;
      // axios({
      //   method: "post",
      //   url: this.po_data_url + "/" + methodName,
      //   data: input,
      //   headers: {
      //     securitykey: localStorage.getItem("security_token"),
      //     Accept: "application/json",
      //     //"Content-Type": "application/json",
      //    ...(isFormData ? {} : { "Content-Type": "application/json" })
      //   },
      // })
      //   .then((response) => {
      //     responseCallBack(response);
      //   })
      //   .catch((error) => {
      //     errorCallBack(error);
      //     ShowError("Erro : " + error);
      //   });
      ServiceExecutorProxy.executeService(methodName, input,this.po_data_url,responseCallBack, errorCallBack);
    }
  }
}
